import api from "@/utils/api";
import { ApiResponse } from "@/utils/api/ApiProps";

export const searchQuery = async (query: string) => {
  if (!query.trim()) return null;

  try {
    const response = await api.req({
      url: `/search?query=${encodeURIComponent(query)}`,
      method: api.Method.GET,
    });

    return response;
  } catch (error) {
    console.error("Search API Error:", error);
    throw error;
  }
};

export const updateOwner = async ({
  payload,
}: any): Promise<ApiResponse> => {
  const response = await api.req({
    url: "/leads/assign_lead",
    method: api.Method.POST,
    body: payload,
  });
  return response;
};

export const setReminder = async ({ params }: any) => {
  const response = await api.req({
    url: "/leads/reminder_lead",
    method: api.Method.POST,
    body: params
  })
  return response;
}

export const deleteLeads = async ({ params }: any) => {
  const response = await api.req({
    url: "/leads/delete_lead",
    method: api.Method.POST,
    body: params
  })
  return response;
  
}
